import { string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { MessageService, ValidatorType } from '@philips-internal/oswald-ui-core/lib/services/index.js';
const OUT_OF_RANGER_VALIDATOR = 'outOfRangerValidator';
var MenssageStatus;
(function (MenssageStatus) {
    MenssageStatus["OK"] = "N";
    MenssageStatus["ERROR"] = "E";
    MenssageStatus["WARNING"] = "A";
})(MenssageStatus || (MenssageStatus = {}));
async function outOfRangerValidator(_, { status = MenssageStatus.OK, message = '' } = {}) {
    switch (status) {
        case MenssageStatus.ERROR:
            return [{
                    message: MessageService.translate('message.value-out-of-reference') + '. ' + message,
                    name: OUT_OF_RANGER_VALIDATOR,
                    type: ValidatorType.DEFAULT,
                    valid: false,
                }];
        case MenssageStatus.WARNING:
            return [{
                    message: message,
                    name: OUT_OF_RANGER_VALIDATOR,
                    type: ValidatorType.WARNING,
                    valid: true,
                }];
        default:
            return [{
                    message: '',
                    name: OUT_OF_RANGER_VALIDATOR,
                    valid: true,
                }];
    }
}
outOfRangerValidator.optionTypes = {
    message: string,
    status: string
};
export { OUT_OF_RANGER_VALIDATOR, outOfRangerValidator, };
//# sourceMappingURL=out-of-ranger-validator.js.map